import { render, staticRenderFns } from "./DamageManagerRow.vue?vue&type=template&id=80ca3b22&scoped=true"
import script from "./DamageManagerRow.vue?vue&type=script&lang=js"
export * from "./DamageManagerRow.vue?vue&type=script&lang=js"
import style0 from "./DamageManagerRow.vue?vue&type=style&index=0&id=80ca3b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ca3b22",
  null
  
)

export default component.exports